import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/technologies/cybersecurity/page.tsx");
